<template>
  <a-form-model
    :class="$style.formModel"
    layout="vertical"
    :model="form"
    :rules="rules"
    ref="form"
  >
    <div :class="$style.formBox">
      <a-form-model-item :label="$t('hat.broadcast.theme')" prop="theme">
        <a-input
          :placeholder="$t('hat.broadcast.form.inputTheme')"
          v-model="form.theme"
          :maxLength="8"
          @blur="onBlur($event, 'theme')"
        />
      </a-form-model-item>
      <a-form-model-item
        :label="$t('hat.deviceManagement.form.selectDevice')"
        prop="saveType"
      >
        <a-radio-group default-value="DEVICE" v-model="form.saveType">
          <a-radio value="DEVICE">
            {{ $t('hat.electronFence.byDevice') }}
          </a-radio>
          <a-radio value="GROUP">
            {{ $t('hat.electronFence.byGroup') }}
          </a-radio>
          <a-radio value="PROJECT">
            {{ $t('hat.deviceManagement.form.project') }}
          </a-radio>
        </a-radio-group>
      </a-form-model-item>
      <div :class="$style.radioItem">
        <a-form-model-item prop="device" v-if="form.saveType === 'DEVICE'">
          <a-select
            mode="multiple"
            v-model="devices"
            show-search
            option-filter-prop="children"
            :filter-option="true"
            :class="$style.selectList"
            @change="handleChange"
          >
            <a-select-option v-for="item in deviceList" :key="item.id">
              {{ item.value }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item prop="group" v-else-if="form.saveType === 'GROUP'">
          <a-select
            mode="multiple"
            show-search
            option-filter-prop="children"
            :filter-option="true"
            v-model="groups"
            :class="$style.selectList"
            @change="handleChange"
          >
            <a-select-option v-for="item in groupList" :key="item.id">
              {{ item.value }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item
          :label="$t('hat.deviceManagement.form.belongingProject')"
          prop="project"
          v-else
        >
          <project-select
            v-model="form.projectId"
            style="margin-bottom: 8px;"
          />
        </a-form-model-item>
        <!-- <span :class="$style.tipText">共包含1台设备</span> -->
      </div>
    </div>
    <div :class="$style.formBox">
      <a-form-model-item :label="$t('hat.broadcast.content')" prop="content">
        <a-input
          :placeholder="$t('hat.broadcast.form.inputContent')"
          v-model="form.content"
          :maxLength="140"
          @blur="onBlur($event, 'content')"
        />
      </a-form-model-item>
      <a-form-model-item
        :label="$t('hat.broadcast.form.broadcastTime')"
        prop="broadcastTime"
      >
        <a-date-picker
          style="width: 250px;"
          format="YYYY-MM-DD HH:mm:ss"
          v-model="form.broadcastTime"
          :show-time="{ defaultValue: $moment('00:00:00', 'HH:mm:ss') }"
        />
      </a-form-model-item>
      <a-form-model-item
        :label="$t('hat.broadcast.form.listeningReceipt')"
        prop="receipts"
      >
        <a-switch
          default-checked
          v-model="form.receiptStatus"
          style="margin-right: 10px;"
        />
        <span :class="$style.tipText">{{
          $t('hat.broadcast.form.listeningReceiptTip')
        }}</span>
      </a-form-model-item>
    </div>
  </a-form-model>
</template>

<script>
import { Component, Vue, Prop } from 'vue-property-decorator';
import { addBroadcast, putBroadcast } from '@/services/smart-hat/broadcast';
import {
  getDeviceList,
  getGroupList,
} from '@/services/smart-hat/device-management';
import { createFormModal } from '@triascloud/x-components';
import { crossStorageModule } from '@/enum/store.js';
import { replaceContent } from '@/views/hat/utils.js';
import ProjectSelect from '@/views/hat/components/project-select';

@Component({
  components: {
    ProjectSelect,
  },
})
export default class DeviceForm extends Vue {
  @Prop({ type: Object, default: () => {} }) editData;
  @Prop({ type: String, default: '' }) operationType;
  @Prop({ type: String, default: '' }) submitType;

  mounted() {
    this.initData();
    this.getSelectList();
  }
  async initData() {
    if (this.operationType === 'edit') {
      const data = this.editData;
      this.initFormData(data);
    }
    if (this.operationType === 'copy') {
      const data = JSON.parse(JSON.stringify(this.editData));
      // data.theme = `${data.theme}-${this.$moment().format(
      //   'YYYY-MM-DD HH:mm:ss',
      // )}`;
      this.initFormData(data);
    }
  }
  form = {
    broadcastStatus: '',
    broadcastTime: this.$moment(new Date())
      .add(1, 'minute')
      .format('YYYY-MM-DD HH:mm:ss'),
    theme: '',
    content: '',
    idxSaveId: [],
    receiptStatus: false,
    projectId: undefined,
    saveType: 'DEVICE',
  };
  rules = {
    theme: [
      {
        required: true,
        message: this.$t('hat.broadcast.form.requiredTheme'),
      },
      {
        max: 8,
        message: '主题长度不能超过8位',
      },
    ],
    content: [
      {
        required: true,
        message: this.$t('hat.broadcast.form.requiredContent'),
      },
    ],
    saveType: [
      {
        required: true,
        message: this.$t('hat.deviceManagement.form.requiredDevice'),
      },
    ],
    broadcastTime: [
      {
        required: true,
        message: this.$t('hat.broadcast.form.requiredBroadcast'),
      },
    ],
  };
  devices = [];
  groups = [];
  deviceList = [];
  groupList = [];
  @crossStorageModule.State('tenant') tenant;
  async getSelectList() {
    try {
      await Promise.all([this.getDevices(), this.getGroups()]);
    } finally {
      if (this.operationType !== 'add') {
        switch (this.editData.saveType) {
          case 'PROJECT':
            this.form.projectId = this.editData.idxSaveId[0] || undefined;
            break;
          case 'DEVICE':
            this.devices = this.editData.idxSaveId;
            break;
          case 'GROUP':
            this.groups = this.editData.idxSaveId;
            break;
        }
      }
    }
  }
  async getDevices() {
    const data = {
      current: 1,
      size: 500,
    };
    this.deviceList = (await getDeviceList(data)).records.map(item => ({
      id: item.deviceId,
      value: item.userId
        ? `${item.deviceName}(${item.userName})`
        : item.deviceName,
    }));
  }
  async getGroups() {
    const data = {
      current: 1,
      size: 500,
    };
    this.groupList = (await getGroupList(data)).records.map(item => ({
      id: item.pkId,
      value: item.deviceGroupName,
    }));
  }
  handleChange(v) {
    this.form.idxSaveId = v;
  }
  initFormData(data) {
    this.form.broadcastStatus = data.broadcastStatus;
    this.getTimeLag(data.broadcastTime) > 0
      ? (this.form.broadcastTime = this.$moment(data.broadcastTime).format(
          'YYYY-MM-DD HH:mm:ss',
        ))
      : (this.form.broadcastTime = this.$moment(new Date())
          .add(1, 'minute')
          .format('YYYY-MM-DD HH:mm:ss'));
    this.form.theme = data.theme;
    this.form.content = data.content;
    this.form.receiptStatus = data.receiptStatus;
    this.form.saveType = data.saveType;
    this.form.idxSaveId = data.idxSaveId;
  }
  getTimeLag(time) {
    return this.$moment(time).valueOf() - this.$moment(new Date()).valueOf();
  }
  async handleConfirm() {
    const playTime = this.getTimeLag(this.form.broadcastTime) / 1000;
    const text = this.$t('hat.broadcast.form.sendBroadcast');
    const tips = this.$t('hat.broadcast.form.broadcastTip', {
      value: this.timeConversion(playTime),
    });
    await createFormModal(
      () => (
        <div class={this.$style.formTipText}>
          <p>{text}</p>
          <p slot="subTxt">{tips}</p>
        </div>
      ),
      {
        width: '442px',
        title: this.$t('hat.deviceManagement.operateConfirm'),
        onOk: async () => {
          try {
            const type = this.operationType === 'edit';
            if (type) {
              this.form.pkId = this.editData.pkId;
            }
            const str = type
              ? this.$t('hat.deviceManagement.editModal.modified')
              : this.$t('hat.deviceManagement.editModal.addSuccess');
            type
              ? await putBroadcast(this.form)
              : await addBroadcast(this.form);
            this.$message.success(str);
          } catch {
            return false;
          }
        },
      },
    );
  }
  async handleSave() {
    const type = this.operationType === 'edit';
    if (type) {
      this.form.pkId = this.editData.pkId;
    }
    const str = type
      ? this.$t('hat.deviceManagement.editModal.modified')
      : this.$t('hat.deviceManagement.editModal.addSuccess');
    type ? await putBroadcast(this.form) : await addBroadcast(this.form);
    this.$message.success(str);
  }
  onBlur(e, key) {
    const { value } = e.target;
    this.form[key] = replaceContent(value);
  }
  timeConversion(value) {
    if (value < 60) {
      return `1${this.$t('unit.m')}`;
    }
    let time = '';
    let day = parseInt(value / 3600 / 24);
    let hour = parseInt((value / 3600) % 24);
    let minutes = parseInt((value % 3600) / 60);
    if (day > 0) {
      time = time + day + this.$t('screen.days');
    }
    if (hour > 0) {
      time = time + hour + this.$t('hat.screen.hours');
    }
    if (minutes > 0) {
      time = time + minutes + this.$t('unit.m');
    }
    return time;
  }
  getValue() {
    return new Promise((resolve, reject) => {
      this.$refs.form.validate(async valid => {
        if (this.form.saveType === 'DEVICE' && this.devices.length < 1) {
          this.$message.error(
            this.$t('hat.deviceManagement.form.requiredDevice'),
          );
          valid = false;
        }
        if (this.form.saveType === 'GROUP' && this.groups.length < 1) {
          this.$message.error(
            this.$t('hat.deviceManagement.form.requiredGroupId'),
          );
          valid = false;
        }
        if (this.form.saveType === 'PROJECT' && !this.form.projectId) {
          this.$message.error(
            this.$t('hat.deviceManagement.editModal.validate.messageOne'),
          );
          valid = false;
        }
        if (valid) {
          if (this.getTimeLag(this.form.broadcastTime) < 0) {
            // this.$message.error('播报时间不得晚于当前时间！');
            // return;
            this.form.broadcastTime = this.$moment(new Date())
              .add(10, 'second')
              .format('YYYY-MM-DD HH:mm:ss');
          }
          this.submitType === 'confirm'
            ? (this.form.broadcastStatus = 'COMPLETED')
            : (this.form.broadcastStatus = 'DRAFT');
          this.form.broadcastTime = this.$moment(
            this.form.broadcastTime,
          ).format('YYYY-MM-DD HH:mm:ss');
          if (this.form.saveType === 'PROJECT') {
            this.form.idxSaveId = [this.form.projectId];
          }
          delete this.form.projectId;
          try {
            this.submitType === 'confirm'
              ? await this.handleConfirm()
              : await this.handleSave();
            resolve(true);
          } catch {
            reject(false);
          }
        } else {
          reject(false);
        }
      });
    });
  }
}
</script>

<style lang="less" module>
.formModel {
  display: flex;
  justify-content: space-between;
  .formBox {
    width: 49%;
    .radioItem {
      height: 140px;
    }
    .selectList {
      :global {
        .ant-select-selection--multiple {
          max-height: 140px;
          overflow-y: auto;
        }
      }
    }
  }
}
.tipText {
  color: #999999;
}
.formTipText {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  p {
    margin: 0;
  }
}
.selectGroups {
  .row {
    margin-bottom: 10px;
    .add {
      display: flex;
      justify-content: space-between;
      span {
        cursor: pointer;
        color: var(--primary);
      }
    }
  }
}
</style>
